module.exports = __webpack_public_path__ + "media/images/icons/outlined/font-size-1302beb43615d2e51b276ff393785518.svg";